import {Async, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {LegalDocument} from 'Users/models/Claims';

export enum LegalAcceptanceActionType {
  GET_LEGAL_AGREEMENT_TEXT = 'legalAcceptance/GET_LEGAL_AGREEMENT_TEXT',
  LOAD_LEGAL_AGREEMENT_TEXT = 'legalAcceptance/LOAD_LEGAL_AGREEMENT_TEXT',
  ACCEPT = 'legalAcceptance/ACCEPT',
  GET_ALL_AGREEMENTS = 'legalAcceptance/GET_ALL_AGREEMENTS',
  CHANGE_AGREEMENTS = 'legalAcceptance/CHANGE_AGREEMENTS',
}

export const acceptAgreements = (userId: string, ids: string[]) =>
  createAction(LegalAcceptanceActionType.ACCEPT, {userId, ids});
export const getLegalAgreementsText = (ids: string[]) =>
  createAction(LegalAcceptanceActionType.GET_LEGAL_AGREEMENT_TEXT, {ids});
export const loadLegalAgreementsText = (texts: Async<LegalAgreementDictionary>) =>
  createAction(LegalAcceptanceActionType.LOAD_LEGAL_AGREEMENT_TEXT, {texts});
export const getAllAgreements = () => createAction(LegalAcceptanceActionType.GET_ALL_AGREEMENTS);
export const changeAgreements = (agreements: Async<LegalDocument[]>) =>
  createAction(LegalAcceptanceActionType.CHANGE_AGREEMENTS, agreements);

export type LegalAgreementDictionary = {
  [id: string]: string;
};
type LegalAcceptanceState = {
  legalAgreementTexts: Async<LegalAgreementDictionary>;
  agreements: Async<LegalDocument[]>;
  texts: Async<LegalAgreementDictionary>;
};

const DEFAULT_STATE: LegalAcceptanceState = {
  legalAgreementTexts: new Empty(),
  agreements: new Empty(),
  texts: new Empty(),
};

type LegalAcceptanceAction = ReturnType<typeof changeAgreements> | ReturnType<typeof loadLegalAgreementsText>;

export default (state: LegalAcceptanceState = DEFAULT_STATE, action: LegalAcceptanceAction): LegalAcceptanceState => {
  switch (action.type) {
    case LegalAcceptanceActionType.LOAD_LEGAL_AGREEMENT_TEXT:
      return {
        ...state,
        legalAgreementTexts: action.payload.texts,
      };
    case LegalAcceptanceActionType.CHANGE_AGREEMENTS:
      return {
        ...state,
        agreements: action.payload,
      };
    default:
      return state;
  }
};
